<template>
  <div>
    <v-dialog
      v-model="model"
      max-width="800"
      persistent
      scrollable
    >
      <material-card
        :title="$t('components.employers.employer_add_file_dialog.add_file_{0}', [$t('enums.'+category)])"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        v-if="model"
      >
        <v-card-text>
          <v-form>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-col xs12 sm12 md8 lg6>
                <multi-file-upload2
                  id="addFileId"
                  @emit-upload-start="saving = true"
                  @emit-upload-end="saving = false"
                  :label="$t('enums.'+category)"
                  :tags="[selectedPlan.UniqueIdentifier]"
                  :categories="[category]"
                  :currentFolder="selectedPlan.Name"
                  :zipDownloadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                  "
                  :fileUploadUrl="
                    settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                  "
                  @emit-files="
                    bindFile($event);
                    saving = false;
                  "
                  @emit-upload-error="
                    error = $event;
                    saving = false;
                  "
                />
              </v-col>
            </v-row>
            <v-row row class="flex-nowrap" align="center">
              <v-col xs12 md4>
                <no-autocomplete-textfield
                  v-model="fileInfo.Code"
                  :label="$t('headers.employer_files.code')"
                ></no-autocomplete-textfield>
              </v-col>
              <v-col xs12 md4>
                <pbas-date-picker
                  style="width: 100%"
                  :label="$t('globals.effective_date')"
                  :value="fileInfo.EffectiveDate"
                  @update-date="fileInfo.EffectiveDate = $event"
                ></pbas-date-picker>
              </v-col>
              <v-col xs12 md4>
                <pbas-date-picker
                  style="width: 100%"
                  :label="$t('headers.employer_files.expiry_date')"
                  :value="fileInfo.ExpiryDate"
                  @update-date="fileInfo.ExpiryDate = $event"
                ></pbas-date-picker>
              </v-col>
            </v-row>
            <v-row row no-gutters class="flex-nowrap" align="center">
              <v-textarea
                :label="$t('components.employers.employer_details.notes')"
                clearable
                counter
                v-model="fileNotes"
              ></v-textarea>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              file = null;
              fileNotes = null;
              fileInfo = {};
              $emit('close')
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="saving"
            @click="save"
            :disabled="file === null || file === undefined"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { locker } from "@/mixins/locker";
import { createEmployerFile } from "@/makeMemberFile";
import MultiFileUpload2 from "@/components/MultiFileUpload2.vue";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";

export default {
  components: {
    ErrorHandler,
    MultiFileUpload2,
    NoAutocompleteTextfield
  },
  mixins: [locker],
  props: ["model", "id", "category"],
  data() {
    return {
      error: null,
      saving: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      valid: false,
      file: undefined,
      fileNotes:null,
      fileInfo: {}
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
    ...mapGetters("common", ["language", "settings"]),
  },  
  methods: {
    ...mapActions("plansMembers", ["addEmployerFile"]),
    bindFile(memberFiles) {
      if (memberFiles.length > 0) {
        const files = createEmployerFile(memberFiles, this.category, this.id);
        this.file = files;
        this.file.Timestamp = this.file.FileSegments[0].Timestamp;
        this.otherFiles = memberFiles;
      } else {
        this.file = null;
        this.otherFiles = [];
      }
    },
    async save() {
      this.saving = true;
      this.file.EmployerId = this.id;
      this.file.PlanName= this.selectedPlan.Name;
      this.file.Note = {
        Text: this.fileNotes,
        Category: "Other",
        Title: this.$t("enums."+this.category),
        MemberIdentityId: this.id,
        IsActive: true,
        EmployerId: this.id
      };
      this.file.Code = this.fileInfo.Code;
      this.file.EffectiveDate = this.fileInfo.EffectiveDate;
      this.file.ExpiryDate = this.fileInfo.ExpiryDate;
      try {
        await this.addEmployerFile({
          planIdentityId: this.selectedPlan.Id,
          employerIdentityId: this.id,
          payload: this.file,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.addOtherFileDialog = false;
        this.$emit('close');
      } catch (error) {
        this.error = error;
      } finally{
      this.saving = false;
      }
    },
  },
};
</script>
